import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA-f2E75MwXteec46qONStyFQ1-ja1wHMA",
  authDomain: "react-visitor-counter-9b0bb.firebaseapp.com",
  projectId: "react-visitor-counter-9b0bb",
  storageBucket: "react-visitor-counter-9b0bb.appspot.com",
  messagingSenderId: "744639015935",
  appId: "1:744639015935:web:04061d73f57767b377d5ca"
};

const app = initializeApp(firebaseConfig);

// 🔥 THIS LINE MUST BE HERE
export const db = getFirestore(app);
